import LoginForm from "../components/Forms/LoginForm";
import { Paper, Typography, Box, TextField } from "@mui/material";
import { useStyles } from "./loginpage-styles";


const LoginPage = () => {
  const classes = useStyles();

  return (
    <Box className={classes.BgBoxContainer}>
      <Box className={classes.displayBgPaper}>
        <img
          src={"http://admin.pixelstrap.com/viho/assets/images/login/3.jpg"}
          // maxW
          width={"100%"}
          height={"100%"}
          alt="login"
        ></img>
      </Box>

      <Box className={classes.formBgPaper}>{<LoginForm />}</Box>
    </Box>
  );
};

export default LoginPage;
